
import { createComponent, reactive, computed } from "@vue/composition-api";

type Props = {
  lapTimeMsList: number[];
};

export default createComponent({
  props: {
    lapTimeMsList: {
      type: Array,
      default: []
    }
  },
  setup(props: Props) {
    const state = reactive({
      lapTimeMsStrList: computed(() => {
        let ret: {}[] = [];
        // TODO: マジックナンバー
        for (let i = 0; i < 8; ++i) {
          let curLapStr = "";
          if (i < props.lapTimeMsList.length) {
            const curLap =
              i == 0
                ? props.lapTimeMsList[i]
                : props.lapTimeMsList[i] - props.lapTimeMsList[i - 1];

            curLapStr = (curLap / 1000).toFixed(3);
          }
          ret.push({
            timeMs: curLapStr,
            key: `lapTimeMsList${i}`
          });
        }
        return ret;
      })
    });

    return {
      state
    };
  }
});
